import {useCallback, useState} from 'react'

const useBinaryState = (
  initialState = false,
): [boolean, set: VoidFunction, reset: VoidFunction, toggle: VoidFunction] => {
  const [state, setState] = useState<boolean>(initialState)
  const set = useCallback(() => setState(true), [])
  const reset = useCallback(() => setState(false), [])
  const toggle = useCallback(() => setState(!state), [state])
  return [state, set, reset, toggle]
}

export default useBinaryState
